define("SageDotCom/Components/CustomerSuccess/CustomerSuccessRemaining", [
    "jquery",
    "text!SageDotCom/Components/Templates/SpotlightCard.html"
], function ($, _cardTemplate) {

    function CustomerStoryRemainingCollection(scope, storyData, desktopCount, mobileCount) {
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        var remainingDiv = $(scope).find(".remaining-customer-story-listing");
        var storyContainer = remainingDiv.find(".customer-success-stories");
        var isMobile = storyContainer.hasClass("is-mobile");

        var numberToShow = isMobile ? mobileCount : desktopCount;

        var remainingTemplate = _.template(_cardTemplate);
        var html = "";
        for (var i = 0; i < numberToShow && i < storyData.length; i++) {
            html += remainingTemplate(storyData[i]);
        }
        storyContainer.html(html);
    };

    CustomerStoryRemainingCollection.init = function (args) {
        return new CustomerStoryRemainingCollection(args.scope, args.data, args.desktopCount, args.mobileCount);
    };

    return CustomerStoryRemainingCollection;

});
define("SageDotCom/Components/Content/CustomerSuccess/CustomerSuccessRemaining", function(){});

